import type { DropdownContentOptions } from '../types';

/**
 * Walks up the DOM from the given element and returns the first ancestor's
 * z-index that creates a stacking context (position !== static && z-index !== auto).
 *
 * @param element - The DOM element to start the search from.
 * @returns The ancestor's z-index as a number, or 'auto' if no stacking-context ancestor is found.
 */
export function getAncestorZIndex(
  element: HTMLElement,
): DropdownContentOptions['zIndex'] {
  let parent: ParentNode | null = element.parentNode;

  while (
    parent &&
    parent.nodeType === 1 &&
    parent !== document.documentElement
  ) {
    const computedStyle = window.getComputedStyle(parent as Element);
    const position = computedStyle.getPropertyValue('position');
    const zIndex = computedStyle.getPropertyValue('z-index');

    if (position !== 'static' && zIndex !== 'auto') {
      const parsed = parseInt(zIndex, 10);

      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }

    parent = parent.parentNode;
  }

  return 'auto';
}
